<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>
                Vista de consulta con filtros y exportación. 
                Revisa el catálogo completo, busca por nombre/código
                y descarga. Úsala para auditorías rápidas o validación
                de datos.</p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Lista de Materiales
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Activa/inactiva, crea, actualiza y elimina la <b>lista de materiales</b> que operan dentro de AVE para la exclusión de los <b>materiales</b> en los <b>socios de negocio</b>.
        </div>
      </div>
      <!-- Header -->
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex shrink-0">
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Lista de Materiales</div> -->
          <app-status-filters [selectedStatuses]="selectedStatuses"
            [showStatus]="[1,0]" [typeFilter]="'master'"  (selectionFilterApply)="getList()">
          </app-status-filters>
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'" (click)="onExportButtonPressed()" matTooltip="Exportar">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>

          <button mat-icon-button color="primary" (click)="openCreateModal()" matTooltip="Nuevo Registro">
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
          <div style="display:inline-flex">
            <button mat-icon-button [matMenuTriggerFor]="importMenu" matTooltip="Importar archivo">
              <mat-icon>
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0,0,256,256">
                  <g fill="#4f46e5" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                    stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                    font-family="none" font-weight="none" font-size="none" text-anchor="none"
                    style="mix-blend-mode: normal">
                    <g transform="scale(5.12,5.12)">
                      <path
                        d="M30,26v9h-4.18c0.12,-0.38 0.18,-0.78 0.18,-1.2v-7.8zM30,37v9h-13c-1.65,0 -3,-1.35 -3,-3v-5h7.8c1.03,0 1.98,-0.37 2.71,-1zM32,26h16v9h-16zM32,37h16v6c0,1.65 -1.35,3 -3,3h-13zM30,15v9h-4v-7.8c0,-0.42 -0.06,-0.82 -0.18,-1.2zM32,15h16v9h-16zM30,4v9h-5.49c-0.73,-0.63 -1.68,-1 -2.71,-1h-7.8v-5c0,-1.65 1.35,-3 3,-3zM48,7v6h-16v-9h13c1.65,0 3,1.35 3,3zM21.8,36h-17.6c-1.215,0 -2.2,-0.985 -2.2,-2.2v-17.6c0,-1.215 0.985,-2.2 2.2,-2.2h17.6c1.215,0 2.2,0.985 2.2,2.2v17.6c0,1.215 -0.985,2.2 -2.2,2.2zM7.968,19l3.494,5.978l-3.831,6.022h2.863l2.521,-4.716l2.533,4.716h2.821l-3.769,-6l3.685,-6h-2.675l-2.455,4.505l-2.323,-4.505z">
                      </path>
                    </g>
                  </g>
                </svg>
              </mat-icon>
            </button>
            <mat-menu #importMenu="matMenu">
              <button mat-menu-item (click)="downloadSubRouteTemplate()">
                <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
                <span>Descargar Plantilla</span>
              </button>
              <input #my_file style="display: none" type="file" (change)="handleFileInput($event)" accept=".xlsx"
                #hiddenfileinput>
              <button mat-menu-item (click)="hiddenfileinput.click()">
                <mat-icon svgIcon="heroicons_outline:arrow-up-tray"></mat-icon>
                <span>Importar Archivo</span>
              </button>
            </mat-menu>
            <button mat-raised-button style="margin-right: 8px;" type="button" *ngIf="aux_file"
              [disabled]="this.fileToUpload.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
              color="primary" (click)="onMessageConfirm(hiddenfileinput)">
              Importar archivo
            </button>
          </div>
        </div>
      </div>
    </div>

  <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent"  mat-table [dataSource]="dataSource" matSort
            (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>

            <!-- Nombre -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
              <td mat-cell *matCellDef="let element" class="text-sm uppercase leading-tight">
                <b class="f-10">{{element.code}}</b><br>
                {{ element.name }}
              </td>
            </ng-container>

            <!-- Estado -->
            <ng-container matColumnDef="statusId">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let element">
                <mat-slide-toggle class="custom-slide-toggle primary" [checked]="element.statusId == 1"
                  [(ngModel)]="element.statusId" [color]="'success'" (ngModelChange)="onStatusChange($event, element)">
                </mat-slide-toggle>
              </td>
            </ng-container>

            <!-- Acciones -->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left"></th>
              <td mat-cell *matCellDef="let element" class="px-6 py-3 text-left">
                <button mat-icon-button [matMenuTriggerFor]="actionMenu" matTooltip="Acciones">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #actionMenu="matMenu">
                  <button mat-menu-item (click)="openEditModal(element)">
                    <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                    <span>Editar Registro</span>
                  </button>
                  <button mat-menu-item (click)="openOrderModal(element)">
                    <mat-icon svgIcon="heroicons_outline:truck"></mat-icon>
                    <span>Vnas. Horarias de Entrega</span>
                  </button>
                  <button mat-menu-item (click)="openDeleteDialog(element)">
                    <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                    <span>Eliminar Registro</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <!-- Header Row -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white dark:bg-gray-900">
            </tr>

            <!-- Fila principal -->
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
          </table>
        </div>
        <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo sentimos, no
          hay registros para mostrar.
        </div>
      </div>

      <!-- Paginación debería asignar valor a this.pageSize-->
      <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
        <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons [length]="totalItems"
          [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
      </div>
    </div>
  </div>

    <!-- Modales -->
    <ng-template #addModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
      <mat-dialog-content class="modal-content">
        <form #createForm="ngForm">
          <div class="grid grid-cols-2 gap-4">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Código</mat-label>
              <input matInput [(ngModel)]="currentCreateListMaterial.code" name="code" required>
            </mat-form-field>
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Nombre</mat-label>
              <input matInput [(ngModel)]="currentCreateListMaterial.name" name="name"
                oninput="this.value = this.value.toUpperCase()" required>
            </mat-form-field>
          </div>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="createMaterialList()"
          [disabled]="!createForm.valid">Guardar</button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Editar -->
    <ng-template #editModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
      <mat-dialog-content class="modal-content">
        <form #editForm="ngForm">
          <div class="grid grid-cols-2 gap-4">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Código</mat-label>
              <input matInput [(ngModel)]="currentUpdateListMaterial.code" name="code" readonly disabled>
            </mat-form-field>
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Nombre</mat-label>
              <input matInput [(ngModel)]="currentUpdateListMaterial.name" name="name"
                oninput="this.value = this.value.toUpperCase()" required>
            </mat-form-field>
          </div>
          <div class="md:flex items-center text-center">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Material</mat-label>
              <mat-select [(ngModel)]="currentUpdateListMaterial.itemId" name="itemId">
                <mat-option>
                  <ngx-mat-select-search [(ngModel)]="searchMaterial" [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="changueOptionsMaterial($event)" placeholderLabel="Buscar material..."
                    noEntriesFoundLabel="No se encontraron resultados">
                  </ngx-mat-select-search>
                </mat-option>
                @for (item of materialList; track item) {
                <mat-option [value]="item">
                  <b>{{ item.code }}</b> - {{ item.name }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <button mat-raised-button class="sm:ml-4" color="primary" (click)="addMaterialList()"
              [disabled]="!currentUpdateListMaterial.itemId">Agregar</button>
          </div>
          <div class="sticky top-0 z-10 bg-white">
            <div class="sticky top-0 mt-2 sm:mt-0 z-10 bg-gray-100 dark:bg-gray-900">
              <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="dataSourceItem"
                matSort matSortDisableClear multiTemplateDataRows> <!--(matSortChange)="changeSortDetail($event)" -->

                <!-- Código -->
                <ng-container matColumnDef="code">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Código</th>
                  <td mat-cell *matCellDef="let element" class="px-6 text-left text-uppercase">
                    <b class="f-10">{{element.code}}</b><br>
                  </td>
                </ng-container>

                <!-- Nombre -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Nombre</th>
                  <td mat-cell *matCellDef="let element" class="px-6 text-left text-uppercase">
                    {{ element.name }}</td>
                </ng-container>

                <!-- Acciones -->
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef class="px-6 py-3 text-left">
                    <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
                      <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                      <input matInput placeholder="Buscar" autocomplete="off" [formControl]="searchItemControl" />
                    </mat-form-field>
                  </th>
                  <td mat-cell *matCellDef="let element; let i=dataIndex" class="px-6 py-3 text-left">
                    <button mat-icon-button (click)="openDeleteItemDialog(i,element)">
                      <mat-icon color="warn" svgIcon="heroicons_outline:trash"></mat-icon>
                    </button>
                  </td>
                </ng-container>

                <!-- Header Row -->
                <tr mat-header-row *matHeaderRowDef="displayedColumnsItem"
                  class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsItem;" class="border-b"></tr>
              </table>
              <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
                <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons
                  [length]="totalItemsItem" [pageSize]="pageSizeItem" (page)="changePageDetail($event)"></mat-paginator>
              </div>
            </div>
          </div>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" (click)="updateMaterialList(this.currentUpdateListMaterial._id)"
          [disabled]="!editForm.valid">Guardar</button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal de ventanas horarias -->
    <ng-template #deliveryModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        Ventanas Horarias de Entrega
      </h2>
      <mat-dialog-content class="modal-content">
        <!-- Tabla de Order Delivery -->
        <table mat-table [dataSource]="currentUpdateListMaterial.orderDeliveryWindows"
          class="min-w-500 overflow-y-visible mat-elevation-z">
          <ng-container matColumnDef="days">
            <th mat-header-cell *matHeaderCellDef>Dias</th>
            <td mat-cell *matCellDef="let element">
              {{ getDayNames(element.days) }}
            </td>
          </ng-container>

          <ng-container matColumnDef="hourStart">
            <th mat-header-cell *matHeaderCellDef>Hora Inicio</th>
            <td mat-cell *matCellDef="let element">
              {{ element.hourStart }}
            </td>
          </ng-container>

          <ng-container matColumnDef="hourEnd">
            <th mat-header-cell *matHeaderCellDef>Hora Fin</th>
            <td mat-cell *matCellDef="let element">
              {{ element.hourEnd }}
            </td>
          </ng-container>

          <ng-container matColumnDef="numberOfHoursToDelivery">
            <th mat-header-cell *matHeaderCellDef>Horas para Entrega</th>
            <td mat-cell *matCellDef="let element">
              {{ element.numberOfHoursToDelivery }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
              Estado
            </th>
            <td mat-cell *matCellDef="let element" class="px-6 text-left">
              <mat-slide-toggle [checked]="element.statusId == 1"
                (change)="onStatusOrderChange($event.checked, element)" color="primary">
              </mat-slide-toggle>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
              <button color="primary" mat-button (click)="openAddOrderModal()" matTooltip="Agregar Orden">
                <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
              </button>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="button-container">
                <button mat-icon-button (click)="openAddOrderModal(element)">
                  <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                </button>
                <button mat-icon-button (click)="openDeleteOrder(element)">
                  <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsOrder"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsOrder"></tr>
        </table>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-right">Aceptar</button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Eliminar -->
    <ng-template #deleteModalOrder let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px"></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">
            Confirmar eliminación
          </h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">
          Conservar
        </button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">
          Eliminar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <ng-template #deleteDialog let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
            style="font-size: 32px;"></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Conservar</button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
      </mat-dialog-actions>
    </ng-template>
  </div>

  <!-- Filtros -->
  <app-filter
    (onFilterEvent)="getList()"
    (onCleanEvent)="clearFilters()"
  >
    <app-no-filters-available></app-no-filters-available>
  </app-filter>
</mat-sidenav-container>